<template>
  <div>
    <template v-if="!hasActivities">none</template>
    <ul v-if="hasActivities" class="activity-list">
      <li
        v-for="activity in activities"
        :key="activity"
      >
        {{activity | getEnumSuspiciousActivityName}}
      </li>
    </ul>
  </div>
</template>

<script>
import { getEnumSuspiciousActivityName } from '../autogen/bundle.js';

export default {
  name: 'SuspiciousActivityList',

  props: {
    activities: {
      type: Array,
    },
  },

  computed: {
    hasActivities() {
      const activities = this.activities;

      if(activities === null) {
        return false;
      }

      return activities.length > 0;
    },
  },

  filters: {
    getEnumSuspiciousActivityName,
  },
}
</script>

<style scoped>
.activity-list {
  list-style-type: none;
  padding-left: 0;
}
</style>
